import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { getBill, updateDriverLocation } from '../../../actions/actionCreators';
import { retrieveBill } from '../../../actions/apiCallActions';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default function TrackerHoc(WrappedComponent) {
  class HOC extends Component {
    constructor(props) {
      super(props);
      this.retrieve();
    }

    componentDidMount() {
      this.listenOnChanges();
    }

    /**
     * Calls get-bill-api
     */
    retrieve = () => {
      const {
        props: { match: { params: { intercity, id } } = {} },
      } = this;

      retrieveBill(id, intercity);
    };

    /**
     * Listen on Changes with a specified pusher channel.
     */
    listenOnChanges = () => {
      const {
        props: { match: { params: { id } } = {} },
      } = this;
      const token = window.localStorage.getItem('jwt');

      const echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.REACT_APP_PUSHER_KEY || '2be705cd0658acec3428',
        authEndpoint: process.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
        cluster: 'eu',
        auth: {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        },
      });

      echo
        .private(`order-tracker.${id}`)
        .listen(`.order-tracker`, (e) => {
          getBill(e);
        })
        .listen(`.client-driver-location`, (e) => {
          e.locations.map((l, i) => {
            let ms = Number(i + 1 + '000');
            setTimeout(() => updateDriverLocation(l), ms);
          });
        });
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => ({ ...state });
  return compose(withRouter, connect(mapStateToProps))(HOC);
}
